import WebApp from "@twa-dev/sdk";

// Cienki wrapper nad Telegram WebApp SDK.
// Powod istnienia: type-safety + jedno miejsce do zmian gdy SDK ewoluuje.

export interface TelegramContext {
  readonly user: {
    readonly id: number;
    readonly firstName: string;
    readonly username: string | null;
    readonly languageCode: string;
  } | null;
  readonly initData: string;
  readonly themeParams: {
    readonly bg_color: string | undefined;
    readonly text_color: string | undefined;
    readonly button_color: string | undefined;
    readonly button_text_color: string | undefined;
  };
  readonly platform: string;
  readonly viewport: {
    readonly height: number;
    readonly stableHeight: number;
    readonly isExpanded: boolean;
  };
}

export function initTelegram(): TelegramContext {
  // ready() informuje Telegrama ze webapp jest gotowy -> ukrywa splash screen.
  WebApp.ready();
  // expand() rozszerza Mini App do pelnej wysokosci viewport.
  WebApp.expand();

  const tgUser = WebApp.initDataUnsafe.user;

  return {
    user: tgUser
      ? {
          id: tgUser.id,
          firstName: tgUser.first_name,
          username: tgUser.username ?? null,
          languageCode: tgUser.language_code ?? "en",
        }
      : null,
    initData: WebApp.initData,
    themeParams: {
      bg_color: WebApp.themeParams.bg_color,
      text_color: WebApp.themeParams.text_color,
      button_color: WebApp.themeParams.button_color,
      button_text_color: WebApp.themeParams.button_text_color,
    },
    platform: WebApp.platform,
    viewport: {
      height: WebApp.viewportHeight,
      stableHeight: WebApp.viewportStableHeight,
      isExpanded: WebApp.isExpanded,
    },
  };
}
